import { useVendors } from '../hooks/useVendors'
import VendorsIndex from '../components/vendors/VendorsIndex'
import { useEffect } from 'react'
import { IconChecklistCircle } from 'components/icons'
import { useLocation, useNavigate } from 'react-router-dom'

function Index() {
  const {
    handleChangeLimit,
    handleChangePage,
    handleChangeSearchKeyword,
    handleChangeStatus,
    handleChangeType,
    handleFetchVendors,
    handleOnSearchKeyword,
    limit,
    page,
    searchKeyword,
    setSortingVendor,
    sortDirection,
    sortField,
    stateToast,
    status,
    statusFetchVendors,
    toast,
    toastContainer,
    totalRows,
    type,
    vendors,
  } = useVendors()

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.state && location.state.name && location.state.actionType) {
      let message = ''
      if (stateToast === 'create-success-vendor') {
        message = `Vendor ${location.state.name} berhasil dibuat.`
      } else if (stateToast === 'edit-success-vendor') {
        message = `Vendor ${location.state.name} berhasil diubah.`
      }
      toast(message, 'success', <IconChecklistCircle color="white" />)
    }
    navigate('/inventory/vendors', { replace: true })
  }, [])

  return (
    <div className="content-wrapper" data-testid="vendor_index_wrapper">
      {toastContainer}
      <VendorsIndex
        statusFetch={statusFetchVendors}
        name={searchKeyword}
        type={type}
        data={vendors}
        status={status}
        sortField={sortField}
        sortBy={sortDirection}
        limit={limit}
        pagination={{ page: page || 1, total: totalRows || 0 }}
        onChangeName={handleChangeSearchKeyword}
        onSearchName={handleOnSearchKeyword}
        onChangeType={handleChangeType}
        onChangeStatus={handleChangeStatus}
        onFetchVendor={handleFetchVendors}
        onChangeLimit={handleChangeLimit}
        onChangePage={handleChangePage}
        setSortingVendor={setSortingVendor}
      />
    </div>
  )
}

export default Index
